"use strict";

exports.__esModule = true;
exports.DeviceMTCDataQueryController = DeviceMTCDataQueryController;
var _react = _interopRequireDefault(require("react"));
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _APIQueryController = require("../../API/APIQueryController");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function DeviceMTCDataQueryController(props) {
  var _pagination$sort;
  var dataAccessor = _react["default"].useContext(_DataAccessorContext.DataAccessorContext);
  var query = props.query,
    onData = props.onData,
    children = props.children,
    aggregated = props.aggregated,
    pagination = props.pagination;
  var _query$deviceUuid = query.deviceUuid,
    deviceUuid = _query$deviceUuid === void 0 ? "" : _query$deviceUuid,
    _query$dataItemNames = query.dataItemNames,
    dataItemNames = _query$dataItemNames === void 0 ? [] : _query$dataItemNames,
    _query$interval = query.interval,
    interval = _query$interval === void 0 ? {
      startMillis: 0,
      endMillis: 0
    } : _query$interval;
  var serverQuery = {
    device_uuid: deviceUuid,
    data_item_names: dataItemNames.map(function (item) {
      return item.dataItemName;
    }).join(";"),
    containing: new Date(query.interval.startMillis).toISOString() + "/" + new Date(interval.endMillis).toISOString(),
    number: pagination == null ? void 0 : pagination.number,
    size: pagination == null ? void 0 : pagination.size,
    sort: pagination == null || (_pagination$sort = pagination.sort) == null ? void 0 : _pagination$sort.map(function (colSort) {
      return colSort.property + ":" + colSort.direction.toLowerCase();
    })
  };
  if (aggregated) {
    serverQuery.aggregate_types = query.aggregateTypes.join(";");
  }
  var endpoint = aggregated ? dataAccessor.getAggregatedS3ConnectData : dataAccessor.getRawConnectMTCData;
  return /*#__PURE__*/_react["default"].createElement(_APIQueryController.APIQueryController, {
    load: function load() {
      return aggregated ? Promise.all([endpoint(serverQuery)]) : endpoint(serverQuery);
    },
    query: serverQuery,
    onData: onData,
    pagination: pagination
  }, children);
}